//todo: придумать более лучший вариант передачи сторы или мутаций в сервис

export const userStoreForKeycloack = {
  mutationsName: {
    setCurrentUser: 'user/setCurrentUser',
    addRole: 'user/addRole',
    addGroup: 'user/addGroup',
    setErrorMsg: 'user/setErrorMsg',
    setAccessToken: 'user/setAccessToken'
  }
}
